module.exports = __webpack_public_path__ + "img/ir.ffc703d6.png";